/**
 * This file was auto-generated by Fern from our API Definition.
 */
import { JobAckDetails } from "../types/JobAckDetails";
export const Request = JobAckDetails.optional();
